export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
  homepage: '/',
  login: `/login`,
  recovery: `/recovery`,
  newPassword: `/new-password`,
}
